export enum SalesState {
    ToContact = 1,
    Deal = 2,
    Analyzing = 3,
    Refused = 4,
    ContactedViaEmail = 5,
    ContactedViaSocialMedia = 6,
    Contacted = 7,
    WaitingMeeting = 8
}
